/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import EditableText from 'material/embeds/editabletext/editabletext_container';
import Delete from 'material/embeds/embed/edit/delete/delete_container';
import Correct from 'material/embeds/embed/edit/correct/correct_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/shared/answer/text1/text1_styles';



/* ========== ~~~~~~~~~~ EMBED : ANSWER TEXT 1 : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class AnswerText1 extends Component {
    constructor(props) {
        super(props);
        this.state = { selected: false, fontSize: 'standard' };
        this.characterLimit = 32;
        this.handleSelect = this.handleSelect.bind(this);
        this.validateText = this.validateText.bind(this);
    }
    componentWillMount() {
        this.validateText(this.props.text, true)
    }
    componentDidUpdate(prevProps) {
        if(this.props.text !== null && prevProps.text !== null && (prevProps.text.length !== this.props.text.length)) this.validateText(this.props.text);
    }

    handleSelect(text){
        this.validateText(text);
        this.setState({
            selected: !this.state.selected
        });
    }
    adjustFontSize = (text) => {
        const charAmount = text.length;
        let ansSize = 'standard';
        // 32 chars per line at 13px fontsize
        if (charAmount >= 20) { ansSize = 'medium'; }
        this.setState({
            fontSize: ansSize
        })
    };
    validateText(text, isInitialValidation=false) {
        if(text !== null && text.length > this.characterLimit) { return null; }
        const isValid = this.props.isValid;
        if(text === null) {
            const valid = isInitialValidation ? this.props.text === null ? this.props.text : true : false;
            this.props.updateOptionProperty(this.props.contentId, this.props.optionId, 'isValid', valid)
        } else if (text.length > 0 && !isValid) {
            this.props.updateOptionProperty(this.props.contentId, this.props.optionId, 'isValid', true)
        } else if (text.length === 0 && (isValid || isValid === null)) {
            this.props.updateOptionProperty(this.props.contentId, this.props.optionId, 'isValid', false)
        }
        if(text !== null && text.length > 0) {
            this.adjustFontSize(text);
        }
    }
    render() {
        const placeholderText = 'Type answer...'; // this should come from redux
        return(
            <div className={`text1 ${this.props.classes.text1}`}>
                <span className={`background selected-${this.state.selected} valid-${this.props.isValid}`}><span className={`overlay`}/></span>
                <span className={`icon`} />
                <span className={`text ${this.state.fontSize}`}>
                    <EditableText contentId={this.props.contentId}
                                  contentTitle={null}
                                  isOption={true}
                                  optionId={this.props.optionId}
                                  placeholderText={placeholderText}
                                  isEditable={this.props.isEditable}
                                  onFocus={this.handleSelect}
                                  onBlur={this.handleSelect}
                                  onKeyUp={this.validateText}
                                  preventEnter={true}
                                  characterLimit={this.characterLimit}
                    />
                </span>
                <Delete contentId={this.props.contentId} optionId={this.props.optionId} position={`top right`} />
                <Correct contentId={this.props.contentId} optionId={this.props.optionId} type={`text1`} />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(AnswerText1);
